import axios from 'axios'
const baseURL = process.env.REACT_APP_API_BASE_URL
const createTransaction = (data) => {
    return axios.post(`${baseURL}/api/retail/public/subscription/transaction`,data)
}

export {createTransaction}